import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import WaitTimeConsultBook from "@iscr/views/public/waittime/components/consult_book";
import org_model from "@iscr/models/org_model";
const ConsultWaitTimeIndicator = ({ basic = false, hideIcon, color, info, badge, badgeType, isGlobalBanner = true, hasPrioritizedMessage = false, isStatic = false, label, siteStatus: siteStatusProp, light, }) => {
    var _a, _b;
    const isPriorityOrg = useIsPriorityOrg();
    const siteStatus = siteStatusProp !== null && siteStatusProp !== void 0 ? siteStatusProp : (_a = (globalThis._appppa || globalThis.app)) === null || _a === void 0 ? void 0 : _a.site_status;
    if (!isStatic && (siteStatus === null || siteStatus === void 0 ? void 0 : siteStatus.ready)) {
        const prediction = (_b = siteStatus === null || siteStatus === void 0 ? void 0 : siteStatus.wr_stat) === null || _b === void 0 ? void 0 : _b.prediction;
        const maxWaitTime = siteStatus === null || siteStatus === void 0 ? void 0 : siteStatus.max_wr_wait_display;
        if (!prediction)
            return null;
        const display = shouldDisplay(prediction, maxWaitTime);
        if (!display && isGlobalBanner)
            return null;
    }
    return (_jsx(WaitTimeConsultBook, { basic: basic, hideIcon: hideIcon, color: color, info: info, badge: badge, badgeType: badgeType, hasPrioritizedMessage: isPriorityOrg || (hasPrioritizedMessage && !isGlobalBanner), label: label, siteStatus: siteStatus, light: light }));
};
export function useIsPriorityOrg() {
    var _a, _b, _c;
    const org = (_c = (_b = (_a = globalThis.app) === null || _a === void 0 ? void 0 : _a.runtime) === null || _b === void 0 ? void 0 : _b.org) !== null && _c !== void 0 ? _c : null;
    return useMemo(() => {
        var _a;
        return Boolean(org && (org_model.org_conf_itm(org, "wr_full_skip") || ((_a = org.path) === null || _a === void 0 ? void 0 : _a.find((o) => o.oid === "S-7LgMU"))));
    }, [org]);
}
const shouldDisplay = (prediction, maxWaitDisplayTime) => {
    const { is_supp, is_admin } = app.acl;
    if (is_supp || is_admin)
        return true;
    if (!prediction || !maxWaitDisplayTime) {
        return false;
    }
    const averageWaitTimeMins = prediction.data.pc_98_wait;
    const maxWait = Number(maxWaitDisplayTime);
    return averageWaitTimeMins <= maxWait;
};
export default ConsultWaitTimeIndicator;
